import React from 'react';
import PropTypes from 'prop-types';

class FixedMenu extends React.Component {
  constructor (props) {
    super(props);

    this.menu = null;
    this.menuPosition = 0;

    this.searchSection = null;

    this.scrollY = this.scrollY.bind(this);
    this.checkMenu = this.checkMenu.bind(this);
  }

  scrollY () {
    return window.scrollY || document.documentElement.scrollTop;
  }

  addClass () {
    const arr = this.menu.className.split(' ');
    const searchClassesArray = this.searchSection.className.split(' ');

    if (arr.indexOf(this.props.fixClass) === -1) {
      this.menu.className += ' ' + this.props.fixClass;
    }
    if (searchClassesArray.indexOf(this.props.fixSearchSectionClass) === -1) {
      this.searchSection.className += ' ' + this.props.fixSearchSectionClass;
    }
  }

  removeClass () {
    const re = new RegExp('\\b' + this.props.fixClass + '\\b', 'g');
    const removeSearchClass = new RegExp('\\b' + this.props.fixSearchSectionClass + '\\b', 'g');

    this.menu.className = this.menu.className.replace(re, '').trim();
    if(this.searchSection) {
      this.searchSection.className = this.searchSection.className.replace(removeSearchClass, '').trim();
    }

  }

  checkMenu () {
    this.menuPosition = this.menuPosition < this.menu.offsetTop ? this.menu.offsetTop : this.menuPosition;
    if (this.scrollY() >= this.menuPosition) {
      this.addClass();
    } else {
      this.removeClass();
    }
  };

  componentDidMount (prevProps) {
    this.menu = document.getElementById(this.props.id);
    this.searchSection = document.getElementById(this.props.searchSectionId);

    if (this.menu) {
      this.checkMenu();

      document.addEventListener('scroll', this.checkMenu);
      document.addEventListener('resize', this.checkMenu);
    }
  }

  componentWillUnmount () {
    document.removeEventListener('scroll', this.checkMenu);
    document.removeEventListener('resize', this.checkMenu);
  }

  render () {
    return null;
  }
}

FixedMenu.propTypes = {
  id: PropTypes.string.isRequired,
  searchSectionId: PropTypes.string.isRequired,
  fixClass: PropTypes.string,  // класс для фиксированного меню
  fixSearchSectionClass: PropTypes.string,
};

FixedMenu.defaultProps = {
  fixClass: 'navbar-fixed-top',
  fixSearchSectionClass: 'pushed-search-section',
};

export default FixedMenu;



// WEBPACK FOOTER //
// ./src/ui/Common/FixedMenu.jsx